import React from 'react';
import { ActionCard } from './ActionCard';

interface BooleanToggleProps {
    value: boolean | undefined | null;
    onChange: (value: boolean) => void;
    yesLabel?: string;
    noLabel?: string;
    className?: string;
}

export const BooleanToggle: React.FC<BooleanToggleProps> = ({
    value,
    onChange,
    yesLabel = 'Yes',
    noLabel = 'No',
    className = 'flex gap-4 staggered-fade-in'
}) => {
    return (
        <div className={className}>
            <ActionCard
                selected={value === true}
                onClick={() => onChange(true)}
            >
                {yesLabel}
            </ActionCard>
            <ActionCard
                selected={value === false}
                onClick={() => onChange(false)}
            >
                {noLabel}
            </ActionCard>
        </div>
    );
};
